import { SignUpQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_utils/SignUpQueryParams";
import { QueryParameters as SignUpParams } from "@faire/web-api--source/routes/www/welcome/r";

export const cleanSignUpParams = (
  queryParams: Partial<SignUpParams>
): SignUpQueryParams => {
  return {
    ...queryParams,
    signUp: undefined,
    name: undefined,
    email: undefined,
    brand: undefined,
    product: undefined,
    video: undefined,
    source: undefined,
    page: undefined,
    phone_number: undefined,
    creation_year: undefined,
    storeOpeningDate: undefined,
    linkShopifyStore: undefined,
    leaseSigned: undefined,
    countryIso3: undefined,
  };
};
